import { Close as CloseIcon } from '@mui/icons-material';
import { Box, DialogTitle as MuiDialogTitle, IconButton } from '@mui/material';
import React from 'react';

import Title from './index';

const DialogTitle = ({
  onClose,
  title,
  icon,
  color = 'primary',
  noMargin = false,
}: {
  onClose: () => void;
  title: string;
  icon: React.ReactNode;
  color: string;
  noMargin?: boolean;
}) => {
  return (
    <MuiDialogTitle>
      <Box display="flex" alignItems="start" justifyContent="space-between">
        <Title title={title} icon={icon} color={color} noMargin={noMargin} />
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
    </MuiDialogTitle>
  );
};

export default DialogTitle;
